import { Component, Input } from '@angular/core'
import { CommonModule } from '@angular/common'
import { AbstractControl } from '@angular/forms'
import {ServerErrors} from '../services/validation.service'

interface ErrorObject {
  errorMessage: string;
  properyName?: string;
}
@Component({
  selector: 'app-form-error',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './form-error.component.html',
  styleUrls: ['./form-error.component.css'],
})

export class FormErrorComponent {
  @Input() control?: AbstractControl;
  @Input() serverErrors?: ServerErrors = {};
  @Input() fieldName: string = ''

  get errorMessage(): string {
    if (this.serverErrors && this.fieldName && this.serverErrors[this.fieldName]) {
      let message = "";
      const errors = this.serverErrors[this.fieldName];
      errors.forEach(error => {
        message += error;

      })
      return message;
    }

    if (this.control && this.control.errors && this.control.touched) {
      if (this.control.errors['required']) {
        return 'This field is required';
      }
      if (this.control.errors['email']) {
        return 'Please enter a valid email address';
      }
      if (this.control.errors['minlength']) {
        return `Minimum length is ${this.control.errors['minlength'].requiredLength}`;
      }
      if (this.control.errors['maxlength']) {
        return `Maximum length is ${this.control.errors['maxlength'].requiredLength}`;
      }
      if (this.control.errors['pattern']) {
        return `Invalid format`;
      }
    }

    return '';
  }

  get showError(): boolean {
    return (
      // returns true if a touched field or is invalid or has server errors. '|| false' forces a bool return
      (this.control?.invalid && this.control?.touched) ||
      (this.serverErrors && this.fieldName && Boolean(this.serverErrors[this.fieldName]))
    ) || false;
  }
}
